module.exports = __webpack_public_path__ + "static/img/1370_phase_function_Paper_Points.acce23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1370_phase_function_Paper_Points.png
// module id = h7zs
// module chunks = 0